import { makeAuthenticatedRequest } from './api';

// Read one entity's audit trail (entityType must be in the backend's ENTITY_TYPES allowlist).
export const getAuditEntries = (entityType, entityId, { limit = 50, cursor = null } = {}) =>
  makeAuthenticatedRequest('/audit/entries', { method: 'POST', body: { entityType, entityId, limit, cursor } });

// List bulk-run summaries, optionally filtered to one operation (e.g. 'transfer-clients').
export const getAuditRuns = ({ limit = 20, cursor = null, operation = null } = {}) =>
  makeAuthenticatedRequest('/audit/runs', { method: 'POST', body: { limit, cursor, operation } });

// Read a single bulk run, optionally with its recorded target id chunks.
export const getAuditRun = (batchId, includeTargets = false) =>
  makeAuthenticatedRequest('/audit/run', { method: 'POST', body: { batchId, includeTargets } });
